export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_11.b9aee9a3.mp4";